export enum ProximityFeatureVersion {
  V1 = 1,
  V2 = 2,
}
